/* ******************************** Logged In Scope *****************************
 * Anything that you want to be alive while the user is logged in should be
 * provided here. That means any services, view models, or domain models that are
 * provided here will be alive while the user is logged in, and will be destroyed
 * when the user logs out.
 */

import { TypeService } from '../services/type/type-service';
import { MembersDomainModel } from '../domainModels/members-domain-model';
import { InternalUsersDomainModel } from '../domainModels/internal-users-domain-model.service';
import { PermissionDomainModel } from '../domainModels/permission-domain-model';
import { EmployersDomainModel } from '../domainModels/employers-domain-model';
import { SubmissionsDomainModel } from '../domainModels/submissions-domain-model';
import { ProfileViewModel } from '../views/profile/components/profile-view-model';
import { AlertsDomainModel } from '../domainModels/alerts-domain-model';
import { TransactionDomainModel } from '../domainModels/transaction-domain-model';
import { RemittanceDomainModel } from '../domainModels/remittance-domain-model';
import { ReleaseNotesDomainModel } from '../domainModels/release-notes-domain-model';
import { WebSocketService } from '../services/web-socket.service';

export const domainModelsGloballyScopedToLoginContext = [
  MembersDomainModel,
  InternalUsersDomainModel,
  PermissionDomainModel,
  EmployersDomainModel,
  SubmissionsDomainModel,
  AlertsDomainModel,
  TransactionDomainModel,
  RemittanceDomainModel,
  ReleaseNotesDomainModel,
  RemittanceDomainModel
];

export const viewModelsGloballyScopedToLoginContext = [ProfileViewModel];

export const servicesGloballyScopedToLoginContext = [TypeService, WebSocketService];
